import { render, staticRenderFns } from "./ContactComments.vue?vue&type=template&id=c1e6c77a&"
import script from "./ContactComments.vue?vue&type=script&lang=js&"
export * from "./ContactComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports